
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.06","height":"11.06"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.53 0a5.53 5.53 0 105.53 5.53A5.53 5.53 0 005.53 0zm1.151 8.57q-.427.169-.681.257a1.8 1.8 0 01-.591.088 1.177 1.177 0 01-.8-.252.814.814 0 01-.286-.64 2.325 2.325 0 01.021-.308 4.1 4.1 0 01.069-.355l.352-1.26c.031-.121.059-.235.08-.342a1.517 1.517 0 00.032-.3.456.456 0 00-.1-.336.564.564 0 00-.377-.09 1 1 0 00-.283.042 3.28 3.28 0 00-.248.082l.094-.388q.35-.143.669-.244a1.978 1.978 0 01.6-.1 1.155 1.155 0 01.792.248.824.824 0 01.278.644q0 .082-.019.289a1.933 1.933 0 01-.071.38l-.353 1.254c-.029.1-.055.216-.078.345a1.822 1.822 0 00-.034.293.421.421 0 00.112.341.626.626 0 00.387.091 1.123 1.123 0 00.293-.045 1.666 1.666 0 00.237-.08zm-.063-5.092a.846.846 0 01-.6.23.855.855 0 01-.6-.23.735.735 0 01-.25-.558.743.743 0 01.25-.56.848.848 0 01.6-.233.839.839 0 01.6.233.754.754 0 010 1.118z","fill":"#6b7786"}})])
          )
        }
      }
    